/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Label_AgeInputs */

const en_booking_label_age = /** @type {(inputs: Booking_Label_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Age (optional)`)
};

const es_booking_label_age = /** @type {(inputs: Booking_Label_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edad (opcional)`)
};

const de_booking_label_age = /** @type {(inputs: Booking_Label_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alter (optional)`)
};

const zh_booking_label_age = /** @type {(inputs: Booking_Label_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年龄（可选）`)
};

const ar_booking_label_age = /** @type {(inputs: Booking_Label_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العمر (اختياري)`)
};

const fr_booking_label_age = /** @type {(inputs: Booking_Label_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Âge (facultatif)`)
};

const vi_booking_label_age = /** @type {(inputs: Booking_Label_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuổi (không bắt buộc)`)
};

const sw_booking_label_age = /** @type {(inputs: Booking_Label_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umri (si lazima)`)
};

const th_booking_label_age = /** @type {(inputs: Booking_Label_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อายุ (ไม่บังคับ)`)
};

const bs_booking_label_age = /** @type {(inputs: Booking_Label_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dob (opcionalno)`)
};

const ja_booking_label_age = /** @type {(inputs: Booking_Label_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年齢(任意)`)
};

const ko_booking_label_age = /** @type {(inputs: Booking_Label_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`나이 (선택)`)
};

const pt_booking_label_age = /** @type {(inputs: Booking_Label_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idade (opcional)`)
};

const it_booking_label_age = /** @type {(inputs: Booking_Label_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Età (opzionale)`)
};

const sv_booking_label_age = /** @type {(inputs: Booking_Label_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ålder (valfritt)`)
};

const nl_booking_label_age = /** @type {(inputs: Booking_Label_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leeftijd (facultatief)`)
};

const da_booking_label_age = /** @type {(inputs: Booking_Label_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alder (valgfrit)`)
};

const nb_booking_label_age = /** @type {(inputs: Booking_Label_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alder (valgfritt)`)
};

const fi_booking_label_age = /** @type {(inputs: Booking_Label_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikä (vapaaehtoinen)`)
};

const pl_booking_label_age = /** @type {(inputs: Booking_Label_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiek (nieobowiązkowo)`)
};

const ru_booking_label_age = /** @type {(inputs: Booking_Label_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Возраст (необязательно)`)
};

const tr_booking_label_age = /** @type {(inputs: Booking_Label_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yaş (isteğe bağlı)`)
};

const hi_booking_label_age = /** @type {(inputs: Booking_Label_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयु (वैकल्पिक)`)
};

const id_booking_label_age = /** @type {(inputs: Booking_Label_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umur (opsional)`)
};

const ms_booking_label_age = /** @type {(inputs: Booking_Label_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umur (pilihan)`)
};

const cs_booking_label_age = /** @type {(inputs: Booking_Label_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Věk (nepovinné)`)
};

const el_booking_label_age = /** @type {(inputs: Booking_Label_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ηλικία (προαιρετικό)`)
};

const he_booking_label_age = /** @type {(inputs: Booking_Label_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`גיל (אופציונלי)`)
};

const af_booking_label_age = /** @type {(inputs: Booking_Label_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouderdom (opsioneel)`)
};

const hu_booking_label_age = /** @type {(inputs: Booking_Label_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Életkor (nem kötelező)`)
};

/**
* | output |
* | --- |
* | "Age (optional)" |
*
* @param {Booking_Label_AgeInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_label_age = /** @type {((inputs?: Booking_Label_AgeInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Label_AgeInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_label_age(inputs)
	if (locale === "de") return de_booking_label_age(inputs)
	if (locale === "zh") return zh_booking_label_age(inputs)
	if (locale === "ar") return ar_booking_label_age(inputs)
	if (locale === "fr") return fr_booking_label_age(inputs)
	if (locale === "vi") return vi_booking_label_age(inputs)
	if (locale === "sw") return sw_booking_label_age(inputs)
	if (locale === "th") return th_booking_label_age(inputs)
	if (locale === "bs") return bs_booking_label_age(inputs)
	if (locale === "ja") return ja_booking_label_age(inputs)
	if (locale === "ko") return ko_booking_label_age(inputs)
	if (locale === "pt") return pt_booking_label_age(inputs)
	if (locale === "it") return it_booking_label_age(inputs)
	if (locale === "sv") return sv_booking_label_age(inputs)
	if (locale === "nl") return nl_booking_label_age(inputs)
	if (locale === "da") return da_booking_label_age(inputs)
	if (locale === "nb") return nb_booking_label_age(inputs)
	if (locale === "fi") return fi_booking_label_age(inputs)
	if (locale === "pl") return pl_booking_label_age(inputs)
	if (locale === "ru") return ru_booking_label_age(inputs)
	if (locale === "tr") return tr_booking_label_age(inputs)
	if (locale === "hi") return hi_booking_label_age(inputs)
	if (locale === "id") return id_booking_label_age(inputs)
	if (locale === "ms") return ms_booking_label_age(inputs)
	if (locale === "cs") return cs_booking_label_age(inputs)
	if (locale === "el") return el_booking_label_age(inputs)
	if (locale === "he") return he_booking_label_age(inputs)
	if (locale === "af") return af_booking_label_age(inputs)
	if (locale === "hu") return hu_booking_label_age(inputs)
	return en_booking_label_age(inputs)
});